import type { AvailableRole } from '@risksmart-app/trpc/src/types';
import type { GetAvailableRolesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAvailableRolesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

/**
 * Reshapes the gated, filtered tRPC `getAvailableRoles` result back into the
 * legacy GraphQL `available_roles { id name description }` shape so consumers'
 * data access is unchanged. `description` is widened to `string` (the GraphQL
 * `RoleOutput.description` is non-null) by coercing the nullable DB value.
 */
const mapTrpcRolesToGraphQL = (
  data: AvailableRole[]
): GetAvailableRolesQuery => ({
  available_roles: data.map((role) => ({
    id: role.id,
    name: role.name,
    description: role.description ?? '',
  })),
});

export const useGetAvailableRoles = createQueryHook<
  Record<string, never>,
  AvailableRole[],
  GetAvailableRolesQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.role.getAvailableRoles.queryOptions(),
  mapTrpcDataToGraphQL: mapTrpcRolesToGraphQL,
  graphqlDocument: GetAvailableRolesDocument,
});
